import React from 'react';
import { Grid, Typography, Chip } from '@mui/material';
import moment from 'moment';
import pickup from 'assets/images/pickUp.svg';
import drop from 'assets/images/drop.svg';

function PickUp(props) {
  const tableData = props?.tableData;
  const status = tableData?.status || "NA";
  
  // Function to determine chip color based on status
  const getStatusColor = (status) => {
    const statusLower = status.toLowerCase();
    switch(statusLower) {
      case 'completed':
        return { bg: '#e6f4ea', text: '#1e8e3e' };
      case 'ongoing':
        return { bg: '#e8f0fe', text: '#1a73e8' };
      case 'dispatched':
        return { bg: '#fef7e0', text: '#f9ab00' };
      case 'cancelled':
        return { bg: '#fce8e6', text: '#d93025' };
      default:
        return { bg: '#f1f3f4', text: '#5f6368' };
    }
  };
  
  const statusColor = getStatusColor(status);
  
  return (
    <div className="heightPickUp">
      {/* Status chip at the top */}
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Grid item>
          <Typography className="font14 fontSemi colorGrey">Status</Typography>
        </Grid>
        <Grid item>
          <Chip
            label={status}
            size="small"
            sx={{
              backgroundColor: statusColor.bg,
              color: statusColor.text,
              fontWeight: 500,
              textTransform: 'capitalize',
              borderRadius: '16px',
              '& .MuiChip-label': {
                px: 1.5,
              }
            }}
          />
        </Grid>
      </Grid>
      
      {/* Original PickUp content */}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className='height100'
      >
        <Grid item xs={1} className='pickUpItem'>
          <div className='pickUpImg'></div>
          <img src={pickup} alt="star" className='pickUpPosition' />
        </Grid>
        <Grid item xs={11}>
          <Typography className="font14 fontSemi colorGrey"> Pick Up</Typography>
          <Typography className="font14 fontNormal">
            {tableData?.sourceAddress}
          </Typography>
          <Typography className="font12 fontNormal colorGrey">{moment(tableData?.scheduledTime).format('DD MMM YYYY, hh:mm a')}</Typography>
          <Typography className="font12 fontNormal colorBlue">{tableData?.distance ? tableData?.distance+"KM" : '' }</Typography>
        </Grid>
      </Grid>
      
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className=''
      >
        <Grid item xs={1}>
          <div className='dropImg'><img src={drop} alt="star" /> </div>
        </Grid>
        <Grid item xs={11}>
          <Typography className="font14 fontSemi colorGrey"> Dropping </Typography>
          <Typography className="font14 fontNormal">
            {tableData?.destinationAddress}
          </Typography>
          <Typography className="font12 fontNormal colorGrey">{tableData?.completedAt ? moment(tableData?.completedAt).format('DD MMM YYYY, hh:mm a') : ' '}</Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default PickUp;